import { useReconnectedGames } from '@utils/hooks';

export const AppDataController = ({ refetchUser }: { refetchUser: VoidFunction }) => {
  useReconnectedGames(refetchUser);

  return null;
};
